<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>현금 상품 관리</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="cyan" small fab @click="OnClick_CreateProduct">
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>

      <div style="overflow-x: auto;">
        <v-data-table
          :footer-props="{'items-per-page-options': [20, 50, -1]}"
          :headers="headers"
          :items="product_list"
          :loading="loadingData"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.PID }}</td>
              <td>{{ row.item.NAME }}</td>
              <td>{{ formatCoin(row.item.PRICE) }} 원</td>
              <td>{{ formatCoin(row.item.GEM_AMOUNT) }}</td>
              <td>
                <span :style="{ fontWeight: '900', color: row.item.IS_ACTIVE === 'Y' ? 'blue' : 'red' }">
                  {{ row.item.IS_ACTIVE === 'Y' ? '활성화' : '비활성화' }}
                </span>
              </td>
              <td>
                <v-btn width="80px" color="indigo" class="white--text" small @click="OnClick_EditProduct(row.item)">수정</v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <!-- 생성/수정 다이얼로그 -->
    <v-dialog v-model="dialog" max-width="500" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title class="text-h5 mb-2">
          {{ dialog_mode_create ? '상품 등록하기' : '상품 수정하기' }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            label="상품명"
            v-model="dialog_name"
            outlined
            dense
            class="mb-2"
          ></v-text-field>
          <v-text-field
            label="가격 (원)"
            v-model="dialog_price"
            outlined
            dense
            type="number"
            class="mb-2"
          ></v-text-field>
          <v-text-field
            label="지급 보석 수"
            v-model="dialog_gem_amount"
            outlined
            dense
            type="number"
            class="mb-2"
          ></v-text-field>
          <v-select
            label="활성화 여부"
            v-model="dialog_is_active"
            :items="[{text: '활성화', value: 'Y'}, {text: '비활성화', value: 'N'}]"
            item-text="text"
            item-value="value"
            outlined
            dense
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">취소</v-btn>
          <v-btn color="blue darken-1" text @click="OnSave_Product" :loading="loadingData">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="py-12"/>
  </div>
</template>

<script>
import { pnt_factory_product } from '../../api/pnt_factory';

export default {
  name: 'PntFactoryGameCoinProduct',
  data: () => ({
    loadingData: false,
    dialog: false,
    dialog_mode_create: true,
    dialog_pid: null,
    dialog_name: '',
    dialog_price: 0,
    dialog_gem_amount: 0,
    dialog_is_active: 'Y',
    product_list: [],
    headers: [
      { text: 'PID', value: 'PID' },
      { text: '상품명', value: 'NAME' },
      { text: '가격 (원)', value: 'PRICE' },
      { text: '지급 보석', value: 'GEM_AMOUNT' },
      { text: '활성화', value: 'IS_ACTIVE' },
      { text: '수정', value: 'edit', sortable: false },
    ],
  }),
  created() {
    this.LoadProductList();
  },
  methods: {
    async LoadProductList() {
      this.loadingData = true;
      try {
        const body = await pnt_factory_product.get_product_list();
        this.product_list = body?.product_list || body?.list || [];
      } catch (e) {
        console.error('[PntFactory CoinProduct] get_product_list', e);
      } finally {
        this.loadingData = false;
      }
    },
    OnClick_CreateProduct() {
      this.dialog_mode_create = true;
      this.dialog_pid = null;
      this.dialog_name = '';
      this.dialog_price = 0;
      this.dialog_gem_amount = 0;
      this.dialog_is_active = 'Y';
      this.dialog = true;
    },
    OnClick_EditProduct(item) {
      this.dialog_mode_create = false;
      this.dialog_pid = item.PID;
      this.dialog_name = item.NAME;
      this.dialog_price = item.PRICE;
      this.dialog_gem_amount = item.GEM_AMOUNT;
      this.dialog_is_active = item.IS_ACTIVE || 'Y';
      this.dialog = true;
    },
    async OnSave_Product() {
      if (!this.dialog_name) { alert('상품명을 입력해주세요.'); return; }
      this.loadingData = true;
      try {
        if (this.dialog_mode_create) {
          await pnt_factory_product.create_product({
            name: this.dialog_name,
            price: Number(this.dialog_price),
            gem_amount: Number(this.dialog_gem_amount),
            is_active: this.dialog_is_active,
          });
        } else {
          await pnt_factory_product.edit_product({
            pid: this.dialog_pid,
            name: this.dialog_name,
            price: Number(this.dialog_price),
            gem_amount: Number(this.dialog_gem_amount),
            is_active: this.dialog_is_active,
          });
        }
        alert('저장완료');
        this.dialog = false;
        await this.LoadProductList();
      } catch (e) {
        console.error('[PntFactory CoinProduct] save', e);
        alert('저장 실패');
      } finally {
        this.loadingData = false;
      }
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
}
</style>
